module.exports = __webpack_public_path__ + "static/bg01-f219fa7113dd258d658d0a6ed99a57f5.jpg";